import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info-shadow-box',
  templateUrl: './info-shadow-box.component.html',
  styleUrls: ['./info-shadow-box.component.scss']
})
export class InfoShadowBoxComponent {
  /**
   * Display icon
   */
  @Input() icon!: string;

  /**
   * Display title
   */
  @Input() title!: string;

  /**
   * Display text
   */
  @Input() text!: string;

  /**
   * Button to know if the redirect button has to appear or not
   */
  @Input() hasButton = false;

  /**
   * Text button
   */
  @Input() buttonText = 'InfoShadowBoxComponent.redirectApp';

  /**
   * Text button
   */
  @Input() redirectPath = 'login';

  constructor(private router: Router) {}

  redirectToApp(): void {
    this.router.navigateByUrl(this.redirectPath);
  }
}
